import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import AppButton from '../../Components/MerchantButton';
import maya from "../../Assets/Logo/maya.jpg";
import './UnifiedFormStyles.css';

const UpdatedSQR = ({ navigation }) => {
  const [sqr_updated, setUpdatedSqrStandee] = useState("");
  const handleBack = () => {
    navigation.previous();
  };
  const handleNext = () => {
    if (!sqr_updated) {
      toast.error('Please select Yes or No', { autoClose: 2500, hideProgressBar: true, theme: 'colored' });
      return;
    }
    if (navigation && navigation.go) {
      if (sqr_updated === 'Yes') {
        navigation.go('sqr-photo');
      } else {
        navigation.go('sqr-branding-version');
      }
    }
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">Updated SQR</h4>
              <p className="form-desc">Review or provide additional SQR updates.</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Updated SQR Standee</Form.Label>
                    {/* <Form.Text className="form-note-text d-block">
                      Updated SQR is the 3.0 version, color white, "SCAN NA ALL" SQR. Remember to check "Powered by MAYA"
                    </Form.Text> */}
                    <div className="my-3 text-center">
                      <img
                        src={maya}
                        alt="Updated SQR example"
                        className="img-fluid rounded shadow-sm"
                        style={{ maxWidth: '320px' }}
                      />
                    </div>
                    <div className="form-radio-group">
                      <div className={`form-radio-item${sqr_updated === 'Yes' ? " selected" : ""}`}>
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="sqr_updated"
                            value="Yes"
                            label="Yes"
                            checked={sqr_updated === 'Yes'}
                            onChange={(e) => setUpdatedSqrStandee(e.target.value)}
                            className="form-radio"
                          />
                        </div>
                      </div>
                      <div className={`form-radio-item${sqr_updated === 'No' ? " selected" : ""}`}>
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            name="sqr_updated"
                            value="No"
                            label="No"
                            checked={sqr_updated === 'No'}
                            onChange={(e) => setUpdatedSqrStandee(e.target.value)}
                            className="form-radio"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                        <p className="form-note-text">
                          <em>"Note: Updated SQR is the 3.0 version, color white, "SCAN NA ALL" SQR"</em>
                        </p>
                      </div>
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back 
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                     Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UpdatedSQR;
